import withIconProps from './withIconProps';
import RakutenAiIconSVG from './icon_r_ai_symbol.svg';

export default withIconProps(RakutenAiIconSVG);
